<template>
  <div @click="viewChannel">

  <template v-if="unread.length > 0">
    <div class="ic_new_msg"></div>
    <div class="ic ic9-channel2">
      <div class="count_new_msg">{{unreadCount}}</div>
    </div>
  </template>
  <template v-else>
    <div class="ic ic8-channel"></div>
  </template>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { db } from '../../../firebase'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'channel-unread-counter-tag',
  props: ['externalId'],
  data: (vm) => {
    return {
      unread: [],
      unreadList: [],
      unreadCount: 0,
      currentChannel: vm.externalId,
      userId: localStore.getItem('userid')
    }
  },
  created () {
    this.currentChannel = this.externalId
    this.$watch('currentChannel', (selectedChannelId) => {
      if (selectedChannelId) {
        this.$bindAsArray('unread', db.ref('channels/' + selectedChannelId + '/unread/' + this.userId))
      }
      this.$bindAsArray('unreadList', db.ref('Unread/' + this.userId))
    }, {
      immediate: true
    })
  },
  watch: {
    unread (newUnread) {
      this.unreadCount = newUnread.length
    },
    unreadList (newUnreadList) {
      let data = _.find(newUnreadList, (data) => {
        return (this.currentChannel === data.channelId)
      })
      if (data) {
        this.unreadCount += data.unreadCount
      }
    }
  },
  methods: {
    ...mapActions([
      'updateSelectedChannel',
    ]),
    viewChannel () {
      this.updateSelectedChannel(this.currentChannel)
      return this.$router.push({name: 'courseSectionChannel', params: {uuid: this.userId, selectedCurrentChannel: this.currentChannel, channelType: 'ALL'}})
    }
  }
}
</script>
<style>
.notification-count {
  font-size:10px!important;
}
</style>



// WEBPACK FOOTER //
// src/app/channel/components/ChannelUnreadCounterTag.vue